import { fal } from "@fal-ai/client";

// fal.ai API key configuration
const FAL_API_KEY = "da6ea037-adea-4346-bb6c-b4196c5a6ad0:1b6252d3777ff8ccb31b22aa46f84083";

// Configure fal client
fal.config({
  credentials: FAL_API_KEY,
});

export class FalAIService {
  static async generateVisualization(productImageUrl, userImageUrl) {
    try {
      console.log('Starting AI visualization generation...');
      console.log('Product image URL:', productImageUrl);
      console.log('User image URL:', userImageUrl);

      const result = await fal.subscribe("fal-ai/bytedance/seedream/v4/edit", {
        input: {
          prompt: "Görseldeki mobilyaları görseldeki odaya doğal bir şekilde yerleştir", // Sabit prompt
          image_size: {
            height: 2160,
            width: 3840
          },
          num_images: 1,
          max_images: 1,
          enable_safety_checker: true,
          image_urls: [productImageUrl, userImageUrl]
        },
        logs: true,
        onQueueUpdate: (update) => {
          if (update.status === "IN_PROGRESS") {
            console.log('AI Generation Progress:', update.logs?.map(log => log.message));
          }
        },
      });

      console.log('AI generation completed:', result.data);
      console.log('Request ID:', result.requestId);

      return {
        success: true,
        data: result.data,
        requestId: result.requestId
      };
    } catch (error) {
      console.error('fal.ai API error:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  static async testConnection() {
    try {
      // Test connection with a simple API call
      const result = await fal.subscribe("fal-ai/bytedance/seedream/v4/edit", {
        input: {
          prompt: "test",
          image_size: {
            height: 512,
            width: 512
          },
          num_images: 1,
          max_images: 1,
          enable_safety_checker: true,
          image_urls: [
            "https://storage.googleapis.com/falserverless/example_inputs/seedream4_edit_input_3.png",
            "https://storage.googleapis.com/falserverless/example_inputs/seedream4_edit_input_4.png"
          ]
        }
      });

      return {
        success: true,
        message: 'fal.ai connection successful',
        data: result
      };
    } catch (error) {
      console.error('fal.ai connection test failed:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }
}

export default FalAIService;
